<router-outlet></router-outlet>

<idle-warning-popup></idle-warning-popup>

<p-confirmDialog #cd styleClass="custom-confirm-dialog">
  <ng-template pTemplate="icon">
    <i class="{{cd.icon}}" style="color: orange; font-size: 5rem"></i>
  </ng-template>
  <ng-template pTemplate="message">
    <p [innerHTML]="cd.message"></p>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton class="bg-button-white" [label]="cd.rejectLabel ?? 'No'"
      (click)="cd.onReject()"></button>
    <button type="button" pButton class="bg-blue-link ml-4" [label]="cd.acceptLabel ?? 'Yes'"
      (click)="cd.onAccept()"></button>
  </ng-template>
</p-confirmDialog>

<p-toast />